import React from 'react';

interface SfiLogoProps {
  size?: number;
}

// SFI co-branding lockup (green tree + wordmark) sourced from forests.org.
// Wordmark is pre-recoloured to figma-text so it reads against the dark
// panel background; green tree carries SFI's brand color unchanged.
export const SfiLogo: React.FC<SfiLogoProps> = ({ size = 28 }) => (
  <img
    src="/sfi-logo-light.svg"
    alt="Sustainable Forestry Initiative"
    style={{ height: size, width: 'auto' }}
  />
);
